/** Restyle the live configuration so fields, validation and actions stay intact. */
export function quizFormLayout(section: any, redesign: boolean, addForm = false): any {
  const original = JSON.parse(JSON.stringify(section.quizOriginalSection || section));
  if (!redesign) {
    return original;
  }
  const next = JSON.parse(JSON.stringify(original));
  const visit = (node: any): void => {
    if (node.sectionType === 'tabStrip') {
      node.tabStripStyle = 'enhanced';
    }
    if (node.useContainerStyling && node.showTitle) {
      Object.assign(node, {
        overrideContainerStyles: true,
        containerStyleName: 'none',
        containerClass: 'dw-form-section-container-enhanced qe-card',
        containerTitleClass: 'dw-form-section-container-enhanced-header',
        containerInnerClass: 'dw-form-section-container-enhanced-inner',
        containerAllowCollapse: false,
        containerCollapseDefault: false,
        containerCollapseDefaultExpression: null,
        containerHeaderBackgroundColor: null,
        containerHeaderForegroundColor: null,
        containerHeaderIconColor: null,
        containerWidth: null,
        containerHeight: null
      });
    }
    (node.sections || []).forEach(visit);
    if (node.section) {
      visit(node.section);
    }
  };
  visit(next);
  // The outer CAP width preset must not constrain the redesigned content rail.
  if (addForm) {
    next.overrideContainerStyles = true;
    next.containerStyleName = 'none';
    next.containerWidth = null;
  }
  const details = (next.sections || []).find((node: any) =>
    (node.sections || []).some((child: any) => (child.fields || []).some((field: any) => field.attrName === 'QuizName')));
  const settings = details && details.sections.find((node: any) =>
    (node.fields || []).some((field: any) => field.attrName === 'PassingPercent'));
  if (settings && !addForm) {
    details.sections = details.sections.filter((node: any) => node !== settings);
    const toggleFields = ['UseRandomOrder', 'ShowAnswersOnFail', 'ShowAnswersOnPass', 'UseWeightedAnswers'];
    settings.sections = [false, true].map(toggles => ({
      sectionType: 'form',
      sectionKey: `${settings.sectionKey || 'QuizParameters'}-${toggles ? 'toggles' : 'inputs'}`,
      formStyle: settings.formStyle,
      showTitle: false,
      useContainerStyling: false,
      columnPreferences: { columns: 1, columnLayoutMode: 'grid12', columnDetails: [] },
      fields: settings.fields.filter((field: any) => toggleFields.includes(field.attrName) === toggles)
    }));
    settings.sectionType = 'container';
    settings.fields = [];
    settings.columnPreferences = { ...settings.columnPreferences, columns: 2 };
    next.sections = next.sections.map((node: any) => node === details ? {
      sectionType: 'container', sectionKey: 'QuizEditorOverview', showTitle: false,
      useContainerStyling: false, sections: [details, settings],
      columnPreferences: {
        columns: 2, columnLayoutMode: 'contentAside', columnDetails: [],
        contentAsideOptions: {
          asideColumn: 'last', asidePosition: 'right', asideWidth: '420px', asideMinWidth: '360px', gap: 'var(--space-6)'
        }
      }
    } : node);
  }
  if (details && settings && addForm) {
    details.title = 'Quiz details';
    details.containerHeaderIcon = 'fa fa-clipboard-list';
    details.sections = details.sections.filter((node: any) => node !== settings);
    settings.title = 'Quiz settings';
    settings.containerHeaderIcon = 'fa fa-sliders-h';
    const toggles = ['UseRandomOrder', 'ShowAnswersOnFail', 'ShowAnswersOnPass', 'UseWeightedAnswers'];
    settings.fields = [
      ...settings.fields.filter((field: any) => !toggles.includes(field.attrName)),
      ...settings.fields.filter((field: any) => toggles.includes(field.attrName))
    ].map((field: any) => ({
      ...field, columnItemPreferences: { ...field.columnItemPreferences, newRowBefore: false }
    }));
    settings.columnPreferences = { columns: 2, columnLayoutMode: 'grid12', columnDetails: [] };
    next.sections = next.sections.reduce((sections: any[], node: any) =>
      sections.concat(node === details ? [details, settings] : [node]), []);
  }
  return {
    sectionType: 'container',
    sectionKey: 'QuizEditorLayout',
    showTitle: false,
    useContainerStyling: true,
    overrideContainerStyles: true,
    containerStyleName: 'none',
    containerClass: addForm ? 'qe-layout qe-layout--add' : 'qe-layout',
    containerInnerClass: 'qe-layout__body',
    columnPreferences: { columns: 1, columnLayoutMode: 'grid12', columnDetails: [] },
    sections: [next],
    // Persist the exact previous layout so Original also works after reloading.
    quizOriginalSection: original
  };
}
